export async function fetchFromContentful(query, variables, preview = false) {
    const endpoint = `https://graphql.contentful.com/content/v1/spaces/${process.env.CONTENTFUL_SPACE_ID}`;
    const response = await fetch(endpoint, {
        method: 'POST',
        headers: getContentfulHeader(preview),
        body: JSON.stringify({ query, variables }),
    });
    const json = await response.json();
    if (json.errors) {
        const message = json.errors.map((error) => error.message).join(', ');
        throw new Error(`GraphQL Error: ${message}`);
    }
    return json.data;
}
const getContentfulHeader = (preview) => {
    return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${preview
            ? process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN
            : process.env.CONTENTFUL_ACCESS_TOKEN}`,
    };
};
